export const GRADIENT_BTN = 'linear-gradient(135deg, #49E8FF 0%, #19D7F2 50%, #00B8E6 100%)';
